// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"32":"3306fb8e","178":"12d187f8","199":"1d1ca27e","237":"95f999a4","587":"d5b85146","615":"da1fcfe9","696":"ace27688","766":"8c8253c6","925":"c0a41633"}[chunkId] + ".js";
};